var map = {
	"./1.jpg": 1007,
	"./2.jpg": 1008,
	"./3.jpg": 1009,
	"./4.jpg": 1010,
	"./5.jpg": 1011,
	"./AvatarMaestra.jpg": 90,
	"./AvatarMaestro.jpg": 89,
	"./Female.jpg": 349,
	"./Female2.jpg": 268,
	"./Male.jpg": 348,
	"./Male2.jpg": 267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552;